module.exports = __webpack_public_path__ + "img/beach.be5030ca.webp";